import Vue from "vue"

//'toasted-primary', 'outline', 'bubble Types: 'success, info, error
//auth success messages
export const logginSuccess = () => Vue.toasted.show('authenticated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end auth success messages

//role
export const roleCreateSuccess = () => Vue.toasted.show('role created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleUpdateSuccess = () => Vue.toasted.show('role updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleDeleteSuccess = () => Vue.toasted.show('role deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end role

//role modules
export const moduleCreateSuccess = () => Vue.toasted.show('module created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const moduleDeleteSuccess = () => Vue.toasted.show('module deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end modules

//permissions
export const permissionCreateSuccess = () => Vue.toasted.show('permission created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const permissionDeleteSuccess = () => Vue.toasted.show('permission deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end permissions

//user
export const userCreateSuccess = () => Vue.toasted.show('user created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userUpdateSuccess = () => Vue.toasted.show('user updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userDeleteSuccess = () => Vue.toasted.show('user deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignUserRoleModelSuccess = () => Vue.toasted.show('user asigned role module successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions asigned successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const removedRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions removed successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'info' });
export const uploadProfilePicSuccess = () => Vue.toasted.show('profile picture uploaded successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end users

//customers
export const customerCreateSuccess = () => Vue.toasted.show('customer created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const customerUpdateSuccess = () => Vue.toasted.show('customer updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end customers

//importers
export const importerCreateSuccess = () => Vue.toasted.show('importer created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const importerUpdateSuccess = () => Vue.toasted.show('importer updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end importers

//shippinglines
export const shippinglineCreateSuccess = () => Vue.toasted.show('shipping line created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const shippinglineUpdateSuccess = () => Vue.toasted.show('shipping line updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end shippinglines

//transporters
export const transporterCreateSuccess = () => Vue.toasted.show('transporter created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const transporterUpdateSuccess = () => Vue.toasted.show('transporter updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end transporters

//fileopenings
export const fileCreateSuccess = () => Vue.toasted.show('file created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const fileUpdateSuccess = () => Vue.toasted.show('file updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end fileopenings


//cargoentries
export const cargoCreateSuccess = () => Vue.toasted.show('cargo created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const cargoUpdateSuccess = () => Vue.toasted.show('cargo updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end cargoentries

//shipping department
export const shippingCreateSuccess = () => Vue.toasted.show('shipping details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const shippingUpdateSuccess = () => Vue.toasted.show('shipping details updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end shipping department

//custom release department
export const customreleaseCreateSuccess = () => Vue.toasted.show('custom releases details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const customreleaseUpdateSuccess = () => Vue.toasted.show('custom releases updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end custom release department

//tarrifs
export const tarrifCreateSuccess = () => Vue.toasted.show('tarrif created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const tarrifUpdateSuccess = () => Vue.toasted.show('tarrif updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end tarrifs


//trucks
export const truckCreateSuccess = () => Vue.toasted.show('transporter truck created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const truckUpdateSuccess = () => Vue.toasted.show('transporter truck updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end trucks

//bonds
export const bondCreateSuccess = () => Vue.toasted.show('bond details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const bondUpdateSuccess = () => Vue.toasted.show('bond details updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end bonds

//requisitions
export const requisitionCreateSuccess = () => Vue.toasted.show('truck requisition details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const requisitionUpdateSuccess = () => Vue.toasted.show('truck requisition details updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end requisitions

//bondtrackings
export const bondtrackingCreateSuccess = () => Vue.toasted.show('bond tracking details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const bondtrackingUpdateSuccess = () => Vue.toasted.show('bond tracking details updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end bondtrackings

//trucktrackings
export const trucktrackingCreateSuccess = () => Vue.toasted.show('truck tracking details created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const trucktrackingUpdateSuccess = () => Vue.toasted.show('truck tracking details updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//endtrucktrackings

//interchange
export const interchangeCreateSuccess = () => Vue.toasted.show('container interchange created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const interchangeUpdateSuccess = () => Vue.toasted.show('container interchange updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end interchange

//pettycash
export const pettycashCreateSuccess = () => Vue.toasted.show('petty cash amount created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end petty cash

//dailtransactions
export const dailytransactionCreateSuccess = () => Vue.toasted.show('daily transaction created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const dailytransactionUpdateSuccess = () => Vue.toasted.show('daily transaction updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end dailtransactions

//accounttypes
export const accounttypeCreateSuccess = () => Vue.toasted.show('account type created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const accounttypeUpdateSuccess = () => Vue.toasted.show('account type updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end accounttypes

//pettyaccounts
export const pettyaccountCreateSuccess = () => Vue.toasted.show('petty account created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const pettyaccountUpdateSuccess = () => Vue.toasted.show('petty account updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end pettyaccounts

//invoice
export const invoiceCreateSuccess = () => Vue.toasted.show('invoice created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const invoiceUpdateSuccess = () => Vue.toasted.show('invoice updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end invoice


// WEBPACK FOOTER //
// ./src/successmessages/success.js